import uiI18n from "../i18n";
import { useTranslation as useUiTranslation } from "react-i18next";
import React, {useCallback,useEffect,useRef,useState} from 'react';
import {Link} from 'react-router-dom';
import {useEngagement} from '../context/EngagementContext';
import {engagementApi,searchUrl} from '../Services/engagementService';
import ListBiens from '../components/ListBiens';
import ListVacation from '../components/ListVacation';
// "Recently viewed": the 6 most recent listings (same default as the API, Engagement__RecentlyViewedLimit).
export const RECENTLY_VIEWED_LIMIT = 6;
export function EngagementLinks() {
  useUiTranslation();
  return <nav aria-label={uiI18n.t("ui.my_activity")} className="flex flex-wrap justify-center gap-5 bg-white px-3 py-2 text-green-800">
    {/* <Link to="/favorites">Mes favoris</Link>  
    {/* <Link to="/recently-viewed">Récemment consultées</Link>
    <Link to="/recent-searches">Recherches récentes</Link> */}
    </nav>;
}
export default function Engagement({mode='favorites'}) {
  useUiTranslation();
  const {user}=useEngagement();
  return <EngagementContent key={`${user?.uid||'guest'}:${mode}`} mode={mode}/>;
}
function EngagementContent({mode}) {
  useUiTranslation();
  const state=useEngagement(); const {user,refresh}=state;
  const [items,setItems]=useState([]); const [loading,setLoading]=useState(false); const [error,setError]=useState('');
  const [busy,setBusy]=useState(false); const lock=useRef(false); const version=useRef(0);
  const load=useCallback(async()=> {
    const request=++version.current;
    if(!user) { setItems([]); return; }
    if(mode==='favorites') { refresh(); return; }
    setLoading(true); setError('');
    try { const data=await (mode==='recently-viewed'?engagementApi.viewed():engagementApi.searches()); if(request===version.current) setItems(mode==='recently-viewed'&&Array.isArray(data)?data.slice(0,RECENTLY_VIEWED_LIMIT):data); }
    catch(e) { if(request===version.current) setError(e.message); }
    finally { if(request===version.current) setLoading(false); }
  },[mode,user,refresh]);
  useEffect(()=> {
    const requests = version;
    setItems([]);
    load();
    window.addEventListener('focus',load);
    return ()=> {
      requests.current++;
      window.removeEventListener('focus',load);
    };
  },[load]);
  async function remove(id) { if(lock.current)return;lock.current=true;setBusy(true);try {await engagementApi.deleteSearch(id);await load();}catch(e){setError(e.message);}finally{lock.current=false;setBusy(false);} }
  const favorites=mode==='favorites'; const data=favorites?state.favorites:items;
  const title=favorites?uiI18n.t("my_favorites"):mode==='recently-viewed'?uiI18n.t("ui.recently_viewed"):uiI18n.t("ui.recent_search_history");
  return <main className="mx-auto max-w-7xl p-5"><h1 className="my-5 text-3xl font-bold">{title}</h1>
    {!state.user ? <Link to="/SignIn">{uiI18n.t("ui.sign_in_to_view_your_activity")}</Link> : <>
    <button className="lina-action mb-4" onClick={load} disabled={loading||state.loading}>{uiI18n.t("ui.refresh")}</button>
    {(favorites?state.error:error) && <p role="alert">{favorites?state.error:error}</p>}
    {/* A background reload (window focus, refresh button) keeps the displayed data: no loading text over it. */}
    {(favorites?state.loading:loading) && !data.length && <p role="status">{uiI18n.t("ui.loading_218")}</p>}
    {!(favorites?state.loading:loading) && !data.length && !(favorites?state.error:error) && <p>{uiI18n.t("ui.nothing_here_yet")}</p>}
    {mode==='recent-searches' ? <><button className="lina-action-danger" disabled={busy||!data.length} onClick={()=>remove()}>{uiI18n.t("ui.clear_history")}</button><ul>{data.map(s=><li key={s.id} className="my-3 rounded-xl border p-4"><Link to={searchUrl(s)}>{[s.kind==='vacation'?uiI18n.t("ui.holidays"):s.transaction==='rent'?uiI18n.t("ui.rent"):s.transaction==='sale'?uiI18n.t("ui.sale"):uiI18n.t("ui.all_properties"),s.city,s.delegation,s.category,s.libelle,s.query,s.offersOnly?uiI18n.t("ui.offers_only"):'',s.minPrice!=null?uiI18n.t("ui.min_budget", { price: s.minPrice }):'',s.maxPrice!=null?uiI18n.t("ui.max_budget", { price: s.maxPrice }):'',s.rooms?.length?uiI18n.t("ui.room_filter", { rooms: s.rooms.join(', ') }):'',s.travelers?uiI18n.t("ui.guest_filter", { guests: s.travelers }):''].filter(Boolean).join(' · ')} {uiI18n.t("ui.search_again")}</Link> <button className="lina-action-danger" disabled={busy} onClick={()=>remove(s.id)}>{uiI18n.t("ui.delete")}</button></li>)}</ul></> :
    <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">{data.map(item=>item.kind==='vacation'?<ListVacation key={`${item.kind}:${item.id}`} listing={item} isHome/>:<ListBiens key={`${item.kind}:${item.id}`} listing={item} isHome/>)}</div>}
    </>}
  </main>;
}
